angular.module('TetherApp').directive('tetherDatepicker', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherDatepicker.html'
    }
});
